module.exports = __webpack_public_path__ + "media/images/icons/search-grid-13641783e6b6234ba6d7c15b02c37620.svg";